__turbopack_context__.v({
  "card": "Services-module__vpQYfG__card",
  "desc": "Services-module__vpQYfG__desc",
  "go": "Services-module__vpQYfG__go",
  "grid": "Services-module__vpQYfG__grid",
  "main": "Services-module__vpQYfG__main",
  "name": "Services-module__vpQYfG__name",
  "qr": "Services-module__vpQYfG__qr",
  "text": "Services-module__vpQYfG__text",
});
